import React from 'react';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { ProductOptionValue } from 'src/types';
import { getFormattedPersonalisationAmount } from 'src/utils';
import * as styles from '../../styles/ToggleButton.styles';

interface ToggleButtonProps {
  currency: CurrencyCode;
  value: ProductOptionValue;
  isSelected: boolean;
  onClick: (value: ProductOptionValue | null) => void;
  onFocus?: () => void;
}

export const ToggleButton = ({
  currency,
  value,
  isSelected,
  onClick,
  onFocus,
}: ToggleButtonProps) => {
  const { isNegative = false, value: formattedPriceValue = '' } = value.priceModifier
    ? getFormattedPersonalisationAmount(currency, value.priceModifier)
    : {};

  const handleOnClick = () => {
    const newValue = isSelected ? null : value;

    onClick(newValue);
  };

  return (
    <button
      css={styles.button}
      type="button"
      onClick={handleOnClick}
      onFocus={onFocus}
      aria-pressed={isSelected}
    >
      <span css={styles.innerButtonWrapper}>
        <span
          css={styles.label}
          data-is-selected={isSelected}
          dangerouslySetInnerHTML={{ __html: value.name }}
        />
        {value.priceModifier && (
          <span css={styles.priceModifier}>
            <span data-is-negative={isNegative} css={styles.priceOperator}>
              {isNegative ? <>&minus;</> : <>&#43;</>}
            </span>
            <span>{formattedPriceValue.replace('-', '')}</span>
          </span>
        )}
      </span>
    </button>
  );
};
